<template>
  <section class="section container pt-0">
    <sewing-orders-datatable />
  </section>
</template>

<script>
import SewingOrdersDatatable from "./sewing_orders_datatable/Index.vue";

export default {
  name: "SewingOrderIndex",
  components: {
    SewingOrdersDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
